import { render, staticRenderFns } from "./customerRecord.vue?vue&type=template&id=f272ad26&scoped=true&"
import script from "./customerRecord.vue?vue&type=script&lang=js&"
export * from "./customerRecord.vue?vue&type=script&lang=js&"
import style0 from "./customerRecord.vue?vue&type=style&index=0&id=f272ad26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f272ad26",
  null
  
)

export default component.exports